// extracted by mini-css-extract-plugin
export default {"sticky":"uifZpZkZvjSGrxTENmC1","placeHolderShimmer":"a6F72UyFb8pfQ2khQGwR"};